import { BaseService } from './base-service';
import { KimMhoReportMapper } from '@/core/mappers/kim-mho-report';
import type { KimMHO } from '@/types/KimMHO';
import type {
	GetKimMHOCountHigherRiskFoundParamsDTO,
	GetKimMHOCountHigherRiskFoundDTO,
	GetKimMHOReportResponseDTO,
	GetKimMHOReportRequestDTO
} from '@/core/dto/kim-mho';

export class KimMHOReportService extends BaseService {
	private static instance: KimMHOReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/kim-mho') {
		super();
	}

	public static getInstance(): KimMHOReportService {
		if (!KimMHOReportService.instance) {
			KimMHOReportService.instance = new KimMHOReportService();
		}
		return KimMHOReportService.instance;
	}

	public async getCountHigherRiskFound(
		params: GetKimMHOCountHigherRiskFoundParamsDTO
	): Promise<GetKimMHOCountHigherRiskFoundDTO[]> {
		const url = this.basePath + `/risk/count`;
		const { data } = await this.getInstance().get<GetKimMHOCountHigherRiskFoundDTO[]>(url, { params });
		return data;
	}

	public async getReport(params: GetKimMHOReportRequestDTO): Promise<KimMHO> {
		const url = this.basePath + `/${params.id}`;
		const { data } = await this.getInstance().get<GetKimMHOReportResponseDTO>(url, { params });
		return new KimMhoReportMapper(data).toDomain();
	}
}
